/* global window, document */
import React from 'react';
import { LocaleProvider } from 'antd';
import { addLocaleData, IntlProvider } from 'react-intl';
import { render } from 'react-dom';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import langConfig from './langConfig';
import './antd-overrides.less';
import './index.scss';
import CalendarContainer from './Containers/Calendar/CalendarContainer';
import { EventReducer } from './Reducers/EventReducer';
import { SettingsReducer } from './Reducers/SettingsReducer';
import { ConnectReducer } from './Reducers/ConnectReducer';
import CandidateSlotSchedular from './Containers/CandidateSlotSchedular/CandidateSlotSchedular';
import CandidateSlotProposal from './Containers/CandidateSlotProposal/CandidateSlotProposal';
import { CANDIDATE_ROUTE_PATH } from './Utility/rescheduleLink';
import { PROPOSE_ROUTE_PATH } from './Utility/proposeLink';
import CandidateAvailabilityBooking from './Containers/CandidateAvailabilityBooking/CandidateAvailabilityBooking';
import { BOOK_ROUTE_PATH } from './Utility/bookLink';
import { ApiStatusReducer } from './Reducers/ApiStatusReducer';
import { AppNotificationReducer } from './Reducers/AppNotificationReducer';

const combineReducer = combineReducers({ EventReducer, SettingsReducer, ConnectReducer, ApiStatusReducer, AppNotificationReducer });
const store = createStore(combineReducer, applyMiddleware(thunk));

window.appLocale = langConfig.en;
const { appLocale } = window;
addLocaleData(appLocale.data);

const root = document.getElementById('root');
const load = () =>
  render(
    <Provider store={store}>
      <LocaleProvider locale={appLocale.antd}>
        <IntlProvider locale={appLocale.locale} messages={appLocale.messages}>
          <BrowserRouter>
            <Switch>
              <Route path={CANDIDATE_ROUTE_PATH}>
                <CandidateSlotSchedular />
              </Route>
              <Route path={PROPOSE_ROUTE_PATH}>
                <CandidateSlotProposal />
              </Route>
              <Route path={BOOK_ROUTE_PATH}>
                <CandidateAvailabilityBooking />
              </Route>
              <Route path="/">
                <CalendarContainer />
              </Route>
            </Switch>
          </BrowserRouter>
        </IntlProvider>
      </LocaleProvider>
    </Provider>,
    root
  );

load();
